import React from 'react'

import { Tabs } from 'antd'

import i18n from 'i18n'
import classNames from 'classnames'
import { isGlobal } from 'conf'

import OrgChartTree from 'pages/records/components/OrgChartTree'
import GroupList from 'pages/records/components/GroupList'
import UserList from 'pages/records/components/UserList'

import { safeboxClient } from 'myNet'
// import { getAvatarURL } from 'pages/records/components/helper'
import styles from './style.module.scss'

class SelectUser extends React.Component {
  state = {
    activeKey: 'orgchart',
    licenseEnforce: false,
    activeLicenseSet: null,
  }

  changedEmailList = []

  changedUserList = []

  changedGroupIdList = []

  changedGroupList = []

  componentDidMount() {
    // KR(한국향 조직도)만: 라이센스 없는 사용자 선택 불가 표시용 active 집합 1회 조회.
    if (!isGlobal()) {
      this.fetchActiveLicenses()
    }
  }

  componentDidUpdate(/* prevProps, prevState */) {}

  componentWillUnmount() {}

  fetchActiveLicenses = async () => {
    try {
      const res = await safeboxClient.get('/v1/users/active-licenses')
      const view = res?.data?.data || {}
      // fail-open: enforce=false(비좌석제/bootstrap/flag OFF)면 전원 활성 유지
      if (view.enforce === true) {
        const ids = view.active_officenext_user_ids || []
        this.setState({
          licenseEnforce: true,
          activeLicenseSet: new Set(ids.map(String)),
        })
      }
    } catch (e) {
      // 조회 실패 → 전원 활성(enforce 미설정, 업무 마비 방지)
    }
  }

  renderOrgChart = () => {
    const { defaultEmailList, excludeEmailList, onUserSelectChanged } = this.props
    const { licenseEnforce, activeLicenseSet } = this.state

    const attrs = {
      defaultEmailList,
      excludeEmailList,
      licenseEnforce,
      activeLicenseSet,
      onSelectChanged: (changedEmailList, changedUserList) => {
        this.changedEmailList = changedEmailList
        this.changedUserList = changedUserList

        if (onUserSelectChanged != null) {
          onUserSelectChanged(changedEmailList, changedUserList)
        }
      },
    }

    return <OrgChartTree {...attrs} />
  }

  fetchUserList = async () => {
    const res = await safeboxClient.get('/v1/users')
    this.setState({
      userList: res.data?.data,
    })
  }

  renderUserList = () => {
    const { defaultEmailList, excludeEmailList, onUserSelectChanged } = this.props
    const { userList } = this.state

    console.log(' --- userList : ', userList)

    const attrs = {
      defaultEmailList,
      excludeEmailList,
      onSelectChanged: (changedEmailList, changedUserList) => {
        this.changedEmailList = changedEmailList
        this.changedUserList = changedUserList

        if (onUserSelectChanged != null) {
          onUserSelectChanged(changedEmailList, changedUserList)
        }
      },
    }

    console.log(' ---UserList attrs : ', attrs)

    return <UserList {...attrs} />
  }

  renderGroups = () => {
    const { excludeGroupIds, onGroupSelectChanged } = this.props

    const attrs = {
      excludeGroupIds,
      onSelectChanged: (changedGroupIdList, changedGroupList) => {
        this.changedGroupIdList = changedGroupIdList
        this.changedGroupList = changedGroupList

        if (onGroupSelectChanged != null) {
          onGroupSelectChanged(changedGroupIdList, changedGroupList)
        }
      },
    }

    return <GroupList {...attrs} />
  }

  getTabItems = () => {
    const items = [
      {
        key: 'orgchart',
        label: isGlobal() ? i18n.t('chat.member.members') : i18n.t('record.select.users'),
        children: isGlobal() ? this.renderUserList() : this.renderOrgChart(),
      },
      {
        key: 'groups',
        label: i18n.t('record.select.groups'),
        children: this.renderGroups(),
      },
    ]

    return items
  }

  render() {
    const { userOnly } = this.props

    let elem = null

    if (userOnly === false) {
      const { activeKey } = this.state
      const items = this.getTabItems()

      const tabsAttrs = {
        items,
        activeKey,
        centered: true,
        onChange: (newActiveKey) => {
          // console.log(' --- activeKey ', activeKey);
          this.activeKey = newActiveKey

          this.setState({
            activeKey: this.activeKey,
          })
        },
      }
      elem = <Tabs {...tabsAttrs} />
    } else {
      elem = isGlobal() ? this.renderUserList() : this.renderOrgChart()
    }

    return <div className={classNames(styles.SelectUser)}>{elem}</div>
  }
}

export default SelectUser
